import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import cx from 'classnames';
import { SUBSCRIPTION_RESTRICTED_EMAIL_BODY_LENGTH } from '../../hooks/use-email-length-restriction';

export interface EmailLengthCounterProps {
  emailLength: number;
  emailLengthPercent: number;
  isEmailAtLimit: boolean;
}

export function EmailLengthCounter(props: EmailLengthCounterProps) {
  const { emailLength, emailLengthPercent, isEmailAtLimit } = props;

  function getIndicatorText() {
    return isEmailAtLimit ? 'You reached the maximum character count.' : 'characters';
  }

  return (
    <div className="absolute bottom-2 right-5 flex items-center gap-1.5 text-xs">
      <span className={isEmailAtLimit ? 'text-red-500 font-medium' : 'text-grey-700 font-normal'}>
        {emailLength} / {SUBSCRIPTION_RESTRICTED_EMAIL_BODY_LENGTH} {getIndicatorText()}
      </span>
      <CircularProgress
        variant="determinate"
        value={Math.min(emailLengthPercent, 100)}
        size={22}
        thickness={4}
        color="primary"
        classes={{
          root: cx('rounded-full shadow-[inset_0_0_0_2.5px_var(--color-grey-200)]', {
            '!text-red-500': isEmailAtLimit,
          }),
        }}
      />
    </div>
  );
}
